export function parseLineList(raw?: string | null): string[] {
  if (!raw) return [];
  const ids = Array.from(raw.matchAll(/[0-9A-Za-z]+/g)).map((m) => m[0]);
  const seen = new Set<string>();
  const out: string[] = [];
  for (const id of ids)
    if (!seen.has(id)) {
      seen.add(id);
      out.push(id);
    }
  return out;
}
